import { render, staticRenderFns } from "./StartOrderReferenceButton.vue?vue&type=template&id=49924112&"
import script from "./StartOrderReferenceButton.vue?vue&type=script&lang=js&"
export * from "./StartOrderReferenceButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports